module.exports = __webpack_public_path__ + "static/media/logo-afep.0c4e0f42.svg";